import '../assets/cp-main-catalogue.pdf';
import '../assets/cp-mini-catalogue.pdf';

const initPageTransitions = () => {

    if (!document.getElementById('page-loader')) {
        const loader = document.createElement('div');
        loader.id = 'page-loader';
        document.body.appendChild(loader);
    }

    const loader = document.getElementById('page-loader');


    document.addEventListener('click', (e) => {
        const link = e.target.closest('a');
        if (
            link &&
            link.href &&
            link.href.startsWith(window.location.origin) &&
            !link.getAttribute('target') &&
            !link.getAttribute('download') &&
            !link.href.includes('#')
        ) {
            e.preventDefault();
            const targetUrl = link.href;


            loader.classList.add('animate');

            setTimeout(() => {
                window.location.href = targetUrl;
            }, 300);
        }
    });


    window.addEventListener('pageshow', (event) => {
        if (event.persisted && loader) {
            loader.classList.remove('animate');
        }
    });
};


const initPdfDownloads = () => {
    const downloadFile = async (url, filename) => {
        const loader = document.getElementById('page-loader');
        try {
            if (loader) loader.classList.add('animate');

            const response = await fetch(url);
            if (!response.ok) throw new Error('Failed to fetch file');
            
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = blobUrl;
            a.download = filename || url.split('/').pop();
            
            document.body.appendChild(a);
            a.click();
            
            document.body.removeChild(a);
            window.URL.revokeObjectURL(blobUrl);

            if (loader) {
                setTimeout(() => {
                    loader.classList.remove('animate');
                }, 500);
            }
        } catch (error) {
            console.error('JS download failed, falling back to tab open:', error);
            window.open(url, '_blank');
            if (loader) {
                setTimeout(() => {
                    loader.classList.remove('animate');
                }, 500);
            }
        }
    };

    document.addEventListener('click', (e) => {
        const link = e.target.closest('a');
        if (link && link.href && /\.pdf$/i.test(link.href)) {
            const isDownload = link.getAttribute('download');
            if (isDownload) {
                e.preventDefault();
                downloadFile(link.href, isDownload);
            }
        }
    });
};


const initIcons = () => {
    if (window.lucide) {
        window.lucide.createIcons();
    }
};


const initSwiper = () => {
    const swiperEl = document.querySelector(".mySwiper");
    if (swiperEl && window.Swiper) {
        new window.Swiper(".mySwiper", {
            slidesPerView: 1.1,
            spaceBetween: 20,
            loop: true,
            speed: 1000,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            breakpoints: {
                640: {
                    slidesPerView: 1.2,
                    spaceBetween: 30,
                },
                1024: {
                    slidesPerView: 1.3,
                    spaceBetween: 30,
                }
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            grabCursor: true,
        });
    }
};


const initHeaderScroll = () => {
    window.addEventListener('scroll', () => {
        const header = document.querySelector('header');
        if (header) {
            if (window.scrollY > 50) {
                header.classList.add('py-2');
                header.classList.remove('py-4');
            } else {
                header.classList.add('py-4');
                header.classList.remove('py-2');
            }
        }
    });
};


const initMobileMenu = () => {
    const toggleBtn = document.getElementById('mobile-menu-toggle');
    const closeBtn = document.getElementById('mobile-menu-close');
    const menu = document.getElementById('mobile-menu');
    const menuLinks = document.querySelectorAll('#mobile-menu a');
    const mobileProductsToggle = document.getElementById('mobile-products-toggle');
    const mobileProductsMenu = document.getElementById('mobile-products-menu');

    // Handle mobile menu open/close
    if (toggleBtn && menu) {
        toggleBtn.addEventListener('click', () => {
            menu.classList.remove('translate-x-full');
            document.body.style.overflow = 'hidden';
        });
    }

    if (closeBtn && menu) {
        closeBtn.addEventListener('click', () => {
            menu.classList.add('translate-x-full');
            document.body.style.overflow = '';
        });
    }

    // Close menu when any link is clicked
    menuLinks.forEach(link => {
        link.addEventListener('click', () => {
            menu.classList.add('translate-x-full');
            document.body.style.overflow = '';
        });
    });

    // Handle mobile products submenu toggle
    if (mobileProductsToggle && mobileProductsMenu) {
        const productsChevron = mobileProductsToggle.querySelector('[data-lucide="chevron-down"]');
        mobileProductsToggle.addEventListener('click', (e) => {
            e.preventDefault();
            const isHidden = mobileProductsMenu.classList.contains('hidden');
            if (isHidden) {
                mobileProductsMenu.classList.remove('hidden');
                mobileProductsMenu.classList.add('flex');
                if (productsChevron) productsChevron.classList.add('rotate-180');
            } else {
                mobileProductsMenu.classList.remove('flex');
                mobileProductsMenu.classList.add('hidden');
                if (productsChevron) productsChevron.classList.remove('rotate-180');
            }
        });
    }
};

const initTabs = () => {
    const tabBtns = document.querySelectorAll('.tab-btn');
    const tabContents = document.querySelectorAll('.tab-content');

    if (tabBtns.length === 0 || tabContents.length === 0) return;

    tabBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            const targetId = btn.id.replace('tab-', 'content-');
            const targetContent = document.getElementById(targetId);
            
            if (!targetContent) return;

            tabBtns.forEach(b => {
                b.classList.remove('border-b-2', 'border-primary', 'text-primary', 'active');
                b.classList.add('text-[#BCC1CF]');
            });

            btn.classList.remove('text-[#BCC1CF]');
            btn.classList.add('border-b-2', 'border-primary', 'text-primary', 'active');

            tabContents.forEach(content => {
                content.classList.add('hidden');
            });

            targetContent.classList.remove('hidden');
        });
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        initPageTransitions();
        initPdfDownloads();
        initIcons();
        initSwiper();
        initHeaderScroll();
        initMobileMenu();
        initTabs();
    });
} else {
    initPageTransitions();
    initPdfDownloads();
    initIcons();
    initSwiper();
    initHeaderScroll();
    initMobileMenu();
    initTabs();
}

document.addEventListener('DOMContentLoaded', () => {
    const contactForm = document.getElementById('contactForm');

    if (contactForm) {
        contactForm.addEventListener('submit', (event) => {
            event.preventDefault();

            const formData = {
                name: event.target.name.value,
                email: event.target.email.value,
                message: event.target.message.value,
            };

            // Retrieve existing submissions from local storage
            const submissions = JSON.parse(localStorage.getItem('contactSubmissions')) || [];

            // Add new submission
            submissions.push(formData);

            // Save back to local storage
            localStorage.setItem('contactSubmissions', JSON.stringify(submissions));

            alert('Thank you for your message!');

            // Reset the form
            contactForm.reset();
        });
    }
});


